__webpack_require__.p = "https://static.log.soccer/frontend/";